<template src="./Edit.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import BrandSelect from "@/components/components/BrandSelect"
import CategorySelect from "@/components/components/CategorySelect"
import TypeSelect from "@/components/components/TypeSelect"
import PhotoForm from "@/components/components/PhotoForm"
import DocumentForm from "@/components/components/DocumentForm"
import EditableField from "@/components/components/EditableField"
import productLang from "../../../constants/goods";

const {mapGetters, mapActions} = createNamespacedHelpers('goods/edit')

export default {
  name: "GoodsEdit",
  components: {
    BrandSelect,
    CategorySelect,
    TypeSelect,
    EditableField,
    PhotoForm,
    DocumentForm,
  },
  data() {
    return {
      showOverlay: false,
      isReady: false,
      productId: this.$route.params.id,
      editSwitch: {},
      addingField: [
        'brand-name',
        'deletedPhotos',
        'deletedProductPhotos',
        'categoryIds',
        'typeId',
        'productPhotoUrl',

        'deletedDocuments1',
        'deletedDocuments2',
        'deletedDocuments3',
        'deletedDocuments4',

        'deletedDocumentUrls1',
        'deletedDocumentUrls2',
        'deletedDocumentUrls3',
        'deletedDocumentUrls4',

      ],
      exceptionField: [
        'id',
        'updated_date',
        'newPhotos',
        'newProductPhotos',
        'newDocument1',
        'newDocument2',
        'newDocument3',
        'newDocument4',
        'lastOrderDate',
      ],

      fieldList1: [
        {
          key: 'id',
          label: 'Номер',
          type: 'static',
        },
        {
          key: 'article',
          label: 'Артикль',
          type: 'text',
        },
        {
          key: 'name',
          label: 'Название',
          type: 'text',
        },
        {
          key: 'parent-name',
          label: 'Родитель',
          type: 'text',
        },
        {
          key: 'parentStatus-name',
          label: 'Статус родства',
          type: 'text',
        },
        {
          key: 'seoFlag',
          label: 'Флаг seo',
          type: 'text',
        },
        {
          key: 'isPublished',
          label: 'Опубликован',
          type: 'checkbox',
        },
        {
          key: 'isOnline',
          label: 'Online',
          type: 'checkbox',
        },
        {
          key: 'isShop',
          label: 'Shop',
          type: 'checkbox',
        },
        {
          key: 'showPriceKp',
          label: 'Показывать Цены из КП в CRM',
          type: 'checkbox',
        }
      ],
      fieldList2: [
        {
          key: 'weight',
          label: productLang.weight,
          type: 'text',
        },
        {
          key: 'dimension',
          label: productLang.dimension,
          type: 'text',
        },
        {
          key: 'dimension_type',
          label: productLang.dimension_type,
          type: 'text',
        },
        {
          key: 'characteristic-ru',
          label: 'Характеристика (ru)',
          type: 'textarea',
        },
        {
          key: 'characteristic-en',
          label: 'Характеристика (en)',
          type: 'textarea',
        },
        {
          key: 'characteristic-de',
          label: 'Характеристика (de)',
          type: 'textarea',
        },
        {
          key: 'characteristic-es',
          label: 'Характеристика (es)',
          type: 'textarea',
        },
        {
          key: 'characteristic-it',
          label: 'Характеристика (it)',
          type: 'textarea',
        },
        {
          key: 'characteristic-fr',
          label: 'Характеристика (fr)',
          type: 'textarea',
        },
        {
          key: 'characteristic-pl',
          label: 'Характеристика (pl)',
          type: 'textarea',
        },
        {
          key: 'characteristic-cs',
          label: 'Характеристика (cs)',
          type: 'textarea',
        },
        {
          key: 'characteristic-hu',
          label: 'Характеристика (hu)',
          type: 'textarea',
        },
        {
          key: 'characteristic-ro',
          label: 'Характеристика (ro)',
          type: 'textarea',
        },
        {
          key: 'customs_number',
          label: 'Таможенный номер',
          type: 'text',
        },
        {
          key: 'EAN',
          label: productLang.EAN,
          type: 'text',
        },


        {
          key: 'searchQuery',
          label: 'Поисковый запрос',
          type: 'text',
        },
        {
          key: 'link',
          label: 'Ссылка на товар',
          type: 'text',
        },
        {
          key: 'tags',
          label: 'Теги',
          type: 'text',
        },
        {
          key: 'description-ru',
          label: 'Описание (ru)',
          type: 'textarea',
        },
        {
          key: 'description-en',
          label: 'Описание (en)',
          type: 'textarea',
        },
        {
          key: 'description-de',
          label: 'Описание (de)',
          type: 'textarea',
        },
        {
          key: 'description-es',
          label: 'Описание (es)',
          type: 'textarea',
        },
        {
          key: 'description-it',
          label: 'Описание (it)',
          type: 'textarea',
        },
        {
          key: 'description-fr',
          label: 'Описание (fr)',
          type: 'textarea',
        },
        {
          key: 'description-pl',
          label: 'Описание (pl)',
          type: 'textarea',
        },
        {
          key: 'description-cs',
          label: 'Описание (cs)',
          type: 'textarea',
        },
        {
          key: 'description-hu',
          label: 'Описание (hu)',
          type: 'textarea',
        },
        {
          key: 'description-ro',
          label: 'Описание (ro)',
          type: 'textarea',
        },
        {
          key: 'short_description-ru',
          label: 'Краткое описание (ru)',
          type: 'textarea',
        },
        {
          key: 'short_description-en',
          label: 'Краткое описание (en)',
          type: 'textarea',
        },
        {
          key: 'short_description-de',
          label: 'Краткое описание (de)',
          type: 'textarea',
        },
        {
          key: 'short_description-es',
          label: 'Краткое описание (es)',
          type: 'textarea',
        },
        {
          key: 'short_description-it',
          label: 'Краткое описание (it)',
          type: 'textarea',
        },
        {
          key: 'short_description-fr',
          label: 'Краткое описание (fr)',
          type: 'textarea',
        },
        {
          key: 'short_description-pl',
          label: 'Краткое описание (pl)',
          type: 'textarea',
        },
        {
          key: 'short_description-cs',
          label: 'Краткое описание (cs)',
          type: 'textarea',
        },
        {
          key: 'short_description-hu',
          label: 'Краткое описание (hu)',
          type: 'textarea',
        },
        {
          key: 'short_description-ro',
          label: 'Краткое описание (ro)',
          type: 'textarea',
        },
        {
          key: 'additional_1',
          label: productLang.additional_1,
          type: 'textarea',
        },
        {
          key: 'additional_2',
          label: productLang.additional_2,
          type: 'textarea',
        },
        {
          key: 'additional_3',
          label: productLang.additional_3,
          type: 'textarea',
        },
        {
          key: 'additional_4',
          label: productLang.additional_4,
          type: 'textarea',
        },
        {
          key: 'additional_5',
          label: productLang.additional_5,
          type: 'textarea',
        },
        {
          key: 'additional_6',
          label: productLang.additional_6,
          type: 'textarea',
        },
        {
          key: 'additional_7',
          label: productLang.additional_7,
          type: 'textarea',
        },
        {
          key: 'additional_8',
          label: productLang.additional_8,
          type: 'textarea',
        },
        {
          key: 'additional_9',
          label: productLang.additional_9,
          type: 'textarea',
        },
        {
          key: 'additional_10',
          label: productLang.additional_10,
          type: 'textarea',
        },
        {
          key: 'old_article',
          label: 'Старый артикул',
          type: 'text',
        },
        {
          key: 'garbage_1',
          label: productLang.garbage_1,
          type: 'textarea',
        },
        {
          key: 'garbage_2',
          label: productLang.garbage_2,
          type: 'textarea',
        },
        {
          key: 'donor_name',
          label: 'Донор название',
          type: 'text',
        },
        {
          key: 'donor_link',
          label: 'Донор ссылка',
          type: 'text',
        },
        {
          key: 'orderDescriptions-ru',
          label: 'Рандомное описание(ru)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-en',
          label: 'Рандомное описание(en)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-de',
          label: 'Рандомное описание(de)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-it',
          label: 'Рандомное описание(it)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-es',
          label: 'Рандомное описание(es)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-fr',
          label: 'Рандомное описание(fr)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-und',
          label: 'Рандомное описание(und)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-pl',
          label: 'Рандомное описание(pl)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-cs',
          label: 'Рандомное описание(cs)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-hu',
          label: 'Рандомное описание(hu)',
          type: 'textarea',
        },
        {
          key: 'orderDescriptions-ro',
          label: 'Рандомное описание(ro)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-ru',
          label: 'Уник. описания (ru)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-en',
          label: 'Уник. описания (en)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-de',
          label: 'Уник. описания (de)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-it',
          label: 'Уник. описания (it)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-es',
          label: 'Уник. описания (es)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-fr',
          label: 'Уник. описания (fr)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-pl',
          label: 'Уник. описания (pl)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-cs',
          label: 'Уник. описания (cs)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-hu',
          label: 'Уник. описания (hu)',
          type: 'textarea',
        },
        {
          key: 'uniqueDescriptions-ro',
          label: 'Уник. описания (ro)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-ru',
          label: 'Уник. характеристики (ru)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-en',
          label: 'Уник. характеристики (en)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-de',
          label: 'Уник. характеристики (de)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-it',
          label: 'Уник. характеристики (it)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-es',
          label: 'Уник. характеристики (es)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-fr',
          label: 'Уник. характеристики (fr)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-pl',
          label: 'Уник. характеристики (pl)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-cs',
          label: 'Уник. характеристики (cs)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-hu',
          label: 'Уник. характеристики (hu)',
          type: 'textarea',
        },
        {
          key: 'uniqueCharacteristics-ro',
          label: 'Уник. характеристики (ro)',
          type: 'textarea',
        },
      ],
      fieldListMiddle: [
        {
          key: 'availabilityDe',
          label: productLang.availabilityDe,
          type: 'text',
        },
        {
          key: 'plannedArrivalFromDe',
          label: 'Срок поставки мин. (de)',
          type: 'text',
        },
        {
          key: 'plannedArrivalToDe',
          label: 'Срок поставки макс. (de)',
          type: 'text',
        },
        {
          key: 'price',
          label: productLang.price,
          type: 'number',
        },
        {
          key: 'priceMin',
          label: 'Мин. цена (de)',
          type: 'number',
        },
        {
          key: 'updated_date',
          label: 'Дата обновления товара',
          type: 'static',
        },
        {
          key: 'lastOrderDate',
          label: 'Дата последнего заказа',
          type: 'static',
        },
      ],
      fieldListRight: [
        {
          key: 'availabilityRu',
          label: productLang.availabilityRu,
          type: 'text',
        },
        {
          key: 'plannedArrivalFromRu',
          label: 'Срок поставки мин. (ru)',
          type: 'text',
        },
        {
          key: 'plannedArrivalToRu',
          label: 'Срок поставки макс. (ru)',
          type: 'text',
        },
        {
          key: 'priceRu',
          label: 'Цена (ru)',
          type: 'number',
        },
        {
          key: 'priceRuMin',
          label: 'Мин. цена (ru)',
          type: 'number',
        },
        {
          key: 'siteModels-modelId',
          label: 'Id модели из базы сайта',
          type: 'text',
        },
        {
          key: 'siteArticleId',
          label: 'Id артикула из базы сайта',
          type: 'text',
        }
      ],
      fieldListCategory: [
        {
          key: 'category-ru_name',
          label: 'Категория(ru)',
          type: 'text',
        },
        {
          key: 'category-en_name',
          label: 'Категория(en)',
          type: 'text',
        },
        {
          key: 'category-de_name',
          label: 'Категория(de)',
          type: 'text',
        },
        {
          key: 'category-es_name',
          label: 'Категория(es)',
          type: 'text',
        },
        {
          key: 'category-it_name',
          label: 'Категория(it)',
          type: 'text',
        },
        {
          key: 'category-fr_name',
          label: 'Категория(fr)',
          type: 'text',
        },
        {
          key: 'category-pl_name',
          label: 'Категория(pl)',
          type: 'text',
        },
        {
          key: 'category-cs',
          label: 'Категория(cs)',
          type: 'text',
        },
        {
          key: 'category-hu',
          label: 'Категория(hu)',
          type: 'text',
        },
        {
          key: 'category-ro',
          label: 'Категория(ro)',
          type: 'text',
        },
      ],
      fieldListMultiLang: [
        {
          key: 'ru',
          label: 'RU',
          type: 'text',
        },
        {
          key: 'en',
          label: 'EN',
          type: 'text',
        },
        {
          key: 'de',
          label: 'DE',
          type: 'text',
        },
        {
          key: 'es',
          label: 'ES',
          type: 'text',
        },
        {
          key: 'it',
          label: 'IT',
          type: 'text',
        },
        {
          key: 'fr',
          label: 'FR',
          type: 'text',
        },
        {
          key: 'pl',
          label: 'PL',
          type: 'text',
        },
        {
          key: 'cs',
          label: 'CS',
          type: 'text',
        },
        {
          key: 'hu',
          label: 'HU',
          type: 'text',
        },
        {
          key: 'ro',
          label: 'RO',
          type: 'text',
        },
      ],
      fieldListType: [
        {
          key: 'type-ru',
          label: 'Тип(ru)',
          type: 'text',
        },
        {
          key: 'type-en',
          label: 'Тип(en)',
          type: 'text',
        },
        {
          key: 'type-de',
          label: 'Тип(de)',
          type: 'text',
        },
        {
          key: 'type-es',
          label: 'Тип(es)',
          type: 'text',
        },
        {
          key: 'type-it',
          label: 'Тип(it)',
          type: 'text',
        },
        {
          key: 'type-fr',
          label: 'Тип(fr)',
          type: 'text',
        },
      ],

      photoFile: {},
      photoNumber: 0,
      isReadyCSelect: false,
      isReadyTSelect: false,
      categoryIds: [],
      selectedMarketplace: null,
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'SAVE',
      'DELETE',
      'GET_MARKETPLACES',
      'GET_PRODUCT_MARKETPLACES'
    ]),

    checkInField(fieldName) {
      let fieldListStore = [
          this.fieldList1,
        this.fieldList2,
        this.fieldListMiddle,
        this.fieldListRight,
        // this.fieldListCategory,
        // this.fieldListType
      ]

      for (let key2 in fieldListStore) {
        for (let key in fieldListStore[key2]) {
          if (
              (this.addingField.includes(fieldName) || fieldListStore[key2][key].key === fieldName)
              && !this.exceptionField.includes(fieldName)
          ) {
            return true
          }
        }
      }

      return false
    },
    brandsChange(brand) {
      this.DATA['brand-name'] = brand.name
      this.DATA['brandId'] = brand.id
    },
    getFieldLabel(key) {
      for (let i in this.fieldList) {
        if (this.fieldList[i].key === key) {
          return this.fieldList[i].label
        }
      }

      return ''
    },
    save() {
      this.SAVE({th: this})
      return false
    },
    productDelete() {
      this.$bvModal.show('confirmationDeletion')
      return false
    },
    confirmationGoodsDelete() {
      this.DELETE({th: this})
    },
    initValue() {
      // prepare array value to string
      this.convertToStaring(this.fieldList1)
      this.convertToStaring(this.fieldList2)
      this.convertToStaring(this.fieldListRight)
      this.convertToStaring(this.fieldListMiddle)
      // this.convertToStaring(this.fieldListCategory)
      // this.convertToStaring(this.fieldListType)

      this.$set(this.DATA, 'newPhotos', {})
      this.$set(this.DATA, 'newProductPhotos', {})
      this.$set(this.DATA, 'deletedPhotos', [])
      this.$set(this.DATA, 'deletedProductPhotos', [])

      this.$set(this.DATA, 'newDocument1', {})
      this.$set(this.DATA, 'newDocument2', {})
      this.$set(this.DATA, 'newDocument3', {})
      this.$set(this.DATA, 'newDocument4', {})

      this.$set(this.DATA, 'deletedDocuments1', [])
      this.$set(this.DATA, 'deletedDocuments2', [])
      this.$set(this.DATA, 'deletedDocuments3', [])
      this.$set(this.DATA, 'deletedDocuments4', [])

      this.$set(this.DATA, 'deletedDocumentUrls1', '')
      this.$set(this.DATA, 'deletedDocumentUrls2', '')
      this.$set(this.DATA, 'deletedDocumentUrls3', '')
      this.$set(this.DATA, 'deletedDocumentUrls4', '')

      this.$set(this.DATA, 'productPhotoUrl', '')
      this.photoNumber = 0
      this.categoryUpdate()
      //type
      if (this.DATA['type'] !== null && this.DATA['type'].id !== undefined) {
        this.DATA.typeId = this.DATA['type'].id
        this.$set(this.DATA, 'typeAsArray', [this.DATA['type']])
      } else {
        this.$set(this.DATA, 'typeAsArray', [])
      }
    },
    convertToStaring(fieldList) {
      for (let fieldKey in fieldList) {
        for (let key in this.DATA) {
          if (fieldList[fieldKey].key === key) {
            // check if it value is array
            if (typeof this.DATA[key] === 'object' && Array.isArray(this.DATA[key])) {
              this.$set(this.DATA, key, this.DATA[key].join(' | '))
            } else {
              // boolean convert to string
              if (this.DATA[key] === true) {
                this.$set(this.DATA, key, 'true')
              }
              if (this.DATA[key] === false) {
                this.$set(this.DATA, key, 'false')
              }
            }
          }
        }
      }
    },

    deleteFamagaPhoto(photoId) {
      for (let key in this.DATA.famagaPhotos) {
        if (this.DATA.famagaPhotos[key].id === photoId) {
          this.DATA.famagaPhotos.splice(key, 1)
        }
      }
      this.DATA.deletedPhotos.push(photoId)
    },
    deleteProductPhoto(photoId) {
      for (let key in this.DATA.productPhotos) {
        if (this.DATA.productPhotos[key].id === photoId) {
          this.DATA.productPhotos.splice(key, 1)
        }
      }
      this.DATA.deletedProductPhotos.push(photoId)
    },

    deleteDocuments1(id) {
      for (let key in this.DATA.documentAsArray1) {
        if (this.DATA.documentAsArray1[key].id === id) {
          this.DATA.documentAsArray1.splice(key, 1)
        }
      }
      this.DATA.deletedDocuments1.push(id)
    },
    deleteDocuments2(id) {
      for (let key in this.DATA.documentAsArray2) {
        if (this.DATA.documentAsArray2[key].id === id) {
          this.DATA.documentAsArray2.splice(key, 1)
        }
      }
      this.DATA.deletedDocuments2.push(id)
    },
    deleteDocuments3(id) {
      for (let key in this.DATA.documentAsArray3) {
        if (this.DATA.documentAsArray3[key].id === id) {
          this.DATA.documentAsArray3.splice(key, 1)
        }
      }
      this.DATA.deletedDocuments3.push(id)
    },
    deleteDocuments4(id) {
      for (let key in this.DATA.documentAsArray4) {
        if (this.DATA.documentAsArray4[key].id === id) {
          this.DATA.documentAsArray4.splice(key, 1)
        }
      }
      this.DATA.deletedDocuments4.push(id)
    },

    categoryAdd() {
      this.isReadyCSelect = true
    },
    categoryDelete(id) {
      this.DATA.categoryAsArray = this.DATA.categoryAsArray.filter((el) => {
        return el.id != id
      })
      this.categoryUpdate()
    },
    categoriesChange(category) {
      if (category.id === undefined) {
        return
      }
      this.DATA.categoryAsArray.push({
        id: category.id,
        name: category.name,
        num: this.DATA.categoryAsArray.length + 1,
      })
      this.isReadyCSelect = false
      this.categoryUpdate()
      this.DATA.translations.category[category.id] = category.translations
    },
    categoryUpdate() {
      let ids = []
      for (let key in this.DATA.categoryAsArray) {
        ids.push(this.DATA.categoryAsArray[key].id)
      }
      this.$set(this.DATA, 'categoryIds', ids)
      // clear field category-...
      for (let key in this.DATA) {
        if (key.indexOf('category-') !== -1) {
          delete (this.DATA[key])
        }
      }
    },
    typeChange(type) {
      if (type.id === undefined) {
        return false
      }
      this.DATA.typeAsArray.push({
        id: type.id,
        name: type.name,
      })
      this.isReadyTSelect = false
      this.DATA.typeId = type.id
      this.DATA.translations.type = type.translations
    },
    typeDelete() {
      this.DATA.typeAsArray = []
      this.DATA.typeId = null
    },
    typeAdd() {
      this.isReadyTSelect = true
    },
    getMarketplaceFields(marketplaceId) {
      const marketplace = this.MARKETPLACES.find(mp => mp.id === marketplaceId);
      return marketplace ? marketplace.fields : []; // Return fields or an empty array if not found
    },
    // Dynamically create productMarketplace with fields from the selected marketplace
    getEmptyProductMarketplace(marketplaceId) {
      const marketplace = this.MARKETPLACES.find(mp => mp.id === marketplaceId);

      // Initialize default productMarketplace object
      let productMarketplace = this.PRODUCT_MARKETPLACES.find(pm => pm.marketplaceId === marketplaceId);
      if (!productMarketplace) {
        productMarketplace = {
          marketplaceId, // Add marketplace ID
        };

        // Dynamically add fields with default "" values
        if (marketplace && marketplace.fields) {
          marketplace.fields.forEach(field => {
            productMarketplace[field] = ""; // Initialize empty value for each field
          });
        }

        // Optionally push the dynamically created object into the array to keep it reactive
        this.PRODUCT_MARKETPLACES.push(productMarketplace);
      }

      return productMarketplace;
    },
    async saveMarketplace(marketplaceId) {
      const marketplace = this.MARKETPLACES.find(mp => mp.id === marketplaceId);
      const productMarketplace = this.PRODUCT_MARKETPLACES.find(pm => pm.marketplaceId === marketplaceId);

      const marketplaceName = marketplace ? marketplace.name : `ID ${marketplaceId}`;

      if (!productMarketplace) {
        alert(`No data to save for marketplace: ${marketplaceName}.`);
        return;
      }

      try {
        await this.$store.dispatch('goods/edit/SAVE_PRODUCT_MARKETPLACE', {
          th: this,
          productId: this.productId,
          marketplaceId,
          data: productMarketplace
        });
      } catch (error) {
        // Handle errors gracefully
        console.error(`Error saving data for marketplace "${marketplaceName}":`, error);
        alert(`Failed to save data for marketplace "${marketplaceName}". Please try again.`);
      }
    },
  },
  computed: {
    ...mapGetters([
      'DATA',
      'MARKETPLACES',
      'PRODUCT_MARKETPLACES',
    ]),
    getCategories() {
      let result = []
      let num = 1
      for (let key in this.DATA.categoryAsArray) {
        let buf = {num: num}
        num ++
        for (let key2 in this.DATA.categoryAsArray[key].name) {
          buf[key2] = this.DATA.categoryAsArray[key].name[key2]
        }
        buf['id'] = this.DATA.categoryAsArray[key].id
        result.push(buf)
      }

      return result
    },
    getFieldCategoryTab() {
      let buf = []
      buf.push({
        key: 'num',
        label: '',
      })
      for (let key in this.fieldListMultiLang) {
        buf.push({
          key: this.fieldListMultiLang[key].key,
          label: this.fieldListMultiLang[key].label,
        })
      }

      buf.push({
        key: 'id',
        label: '',
      })

      return buf
    },

    getTypes() {
      let result = []
      for (let key in this.DATA.typeAsArray) {
        let buf = {}
        for (let key2 in this.DATA.typeAsArray[key].name) {
          buf[key2] = this.DATA.typeAsArray[key].name[key2]
        }
        buf['id'] = this.DATA.typeAsArray[key].id
        result.push(buf)
      }

      return result
    },
    marketplaces() {
      return this.$store.getters['goods/edit/MARKETPLACES'];
    },
  },
  mounted: function () {
    if (this.$store.getters.getAllowSection.indexOf('order') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }

    this.GET_DATA({th: this});
    this.GET_MARKETPLACES({th: this});
    this.GET_PRODUCT_MARKETPLACES({th: this});
  },
  created() {
  },
  watch: {
    MARKETPLACES(newMarketplaces) {
      if (newMarketplaces.length > 0 && !this.selectedMarketplace) {
        this.selectedMarketplace = newMarketplaces[0].id;
      }
    },
  },
}
</script>

<style scoped>
.left {
  text-align: left;
}
.submit-button {
  text-align: right;
}
.dummy-btn {
  width: 39px;
  height: 22px;
  display: inline-block;
}
.photo {
  max-height: 6em;
}
.label-col {
  text-align: right;
}
.but-save {
  position:-webkit-sticky;
  position: sticky;
  top: 2em;
  z-index: 50;
}
.but-shadow {
  box-shadow: 5px 5px 30px 5px grey;
}
.text-align-left {
  text-align: left;
}

/* Tabs styling */
.tabs-container {
  margin-bottom: 20px;
}

.tabs {
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
  border-bottom: 2px solid #ccc;
}

.tabs li {
  cursor: pointer;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-bottom: none;
  background-color: #f9f9f9;
  margin-right: 5px;
}

.tabs li.active {
  background-color: white;
  font-weight: bold;
  border-top: 2px solid #007bff;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

/* Fields container styling */
.marketplace-fields-container {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  background-color: #f9f9f9;
}

/* Each field section */
.field-section {
  margin-bottom: 20px;
}

/* Label-input alignment */
.field-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.field-row label {
  width: 150px; /* Ensures labels have the same width */
  text-align: left;
  font-weight: bold;
  margin-right: 10px;
}

.field-row input {
  flex: 1;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

</style>

<style>

</style>